import React, {useEffect} from 'react';
import {useOvermind} from "../Others/OvermindHelper";
import TopWelcomeMessages from "./TopWelcomeMessages";
import {FirebaseHelper} from "../Others/FirebaseHelper";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import DataAdderShowerDeleter from "./DataAdderShowerDeleter";
import {GlobalMethods} from "../Others/GlobalMethods";

const WholeThing = () => {
    const {state, actions} = useOvermind()
    useEffect(() => {
        try {
            FirebaseHelper.init()
        } catch (e) {

        }
    }, [])

    return (
        <div style={GlobalMethods.getWindowHeightWidth()}>

            <TopWelcomeMessages/>

            <BrowserRouter>
                <Switch>
                    <Route path='/:id?' render={props => <DataAdderShowerDeleter {...props} />}/>
                </Switch>
            </BrowserRouter>

        </div>
    );
};

export default WholeThing;
